import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../../factory/factory.utils.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import '@floating-ui/react';
import { FloatingArrow } from '../../Floating/FloatingArrow/FloatingArrow.mjs';
import { FocusTrap } from '../../FocusTrap/FocusTrap.mjs';
import '../../Portal/Portal.mjs';
import { OptionalPortal } from '../../Portal/OptionalPortal.mjs';
import { usePopoverContext } from '../Popover.context.mjs';
import classes from '../Popover.module.css.mjs';
import { useMergedRef } from '../PopoverTarget/use-merged-ref.mjs';
import { closeOnEscape } from './PopoverDropdown.utils.mjs';

const PopoverDropdown = factory((props, ref) => {
  const { children, onKeyDownCapture, className, ...rest } = props;
  const ctx = usePopoverContext();
  const accessibleProps = ctx.withRoles ? {
    "aria-labelledby": ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {};
  const mergedRef = useMergedRef(ref, ctx.floating);
  if (ctx.disabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(OptionalPortal, { ...ctx.portalProps, withinPortal: ctx.withinPortal }, /* @__PURE__ */ React.createElement(FocusTrap, { active: ctx.trapFocus && ctx.opened }, /* @__PURE__ */ React.createElement(
    Box,
    {
      ...accessibleProps,
      ...rest,
      ref: mergedRef,
      onKeyDownCapture: closeOnEscape(ctx.onClose, {
        active: ctx.closeOnEscape,
        onKeyDown: onKeyDownCapture
      }),
      "data-position": ctx.placement,
      className: clsx(classes.dropdown, ctx.opened && classes.dropdownOpened, className, "kohler-popover-dropdown"),
      style: { top: ctx.y ?? 0, left: ctx.x ?? 0, width: ctx.width === "target" ? void 0 : `${ctx.width}px` }
    },
    children,
    /* @__PURE__ */ React.createElement(
      FloatingArrow,
      {
        ref: ctx.arrowRef,
        arrowX: ctx.arrowX,
        arrowY: ctx.arrowY,
        visible: ctx.withArrow,
        position: ctx.placement,
        arrowSize: ctx.arrowSize,
        arrowRadius: ctx.arrowRadius,
        arrowOffset: ctx.arrowOffset,
        arrowPosition: ctx.arrowPosition,
        className: clsx(classes.arrow)
      }
    )
  )));
});

export { PopoverDropdown };
